/************************************************************
 * Project: Book App
 * Author: Marcos Santos - A01072792
 * BCIT class Comp2913 - ReactJS by Daniel Takeuchi
 * Date: October, 10, 2020.
 * Description: Assignment - Book App
 * https://github.com/maasantos10/
 ************************************************************/

import React from 'react';
import { Container } from './styles';

import './style.css';

interface ListProps {
  
  id: string;
  link: string;
  title: string;
  categories: string;
  imgUrl: string;
  description: string;
  className?: string;
}

const ListContent: React.FC<ListProps> = ({
  id,
  link,
  title,
  categories,
  imgUrl,
  description,
  className = '',
  children,
}) => {
  return (
    <Container key={id} className={className} >
      {children}
      
          <div className='books'>
            <a href={link}>
              <div className="alignLeft">
              {imgUrl && (
                <img width="100px" src={imgUrl} alt={title} />
              )}
              </div>
            </a>
            <div className="alignRight" >
              <a href={link}>
                <h4>{title}</h4>
              </a>
              <div className="internalAlignRighFirst">
              <p><b>id:</b> {id}</p>
              <p><b>Description:</b> {description}</p>
              </div>
              <div className="internalAlignRighSecond">
                <span  >
                <p><i>Category: {categories}</i></p>
                </span>
              </div>
            </div>
          </div>
    </Container>
  );
};

export default ListContent;
